import { render, staticRenderFns } from "./project__inner.vue?vue&type=template&id=483c55aa&"
import script from "./project__inner.vue?vue&type=script&lang=js&"
export * from "./project__inner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports